import { UIMediaQuery } from './types';

export const ui_query_to_text: { [query in UIMediaQuery]: string } = {
    m: '(width < 750px)',
    mt: '(width <= 1050px)',
    t: '(width >= 750px) and (width <= 1050px)',
    td: '(width >= 750px)',
    d: '(width > 1050px)'
};

export function uiIsMedia(query: UIMediaQuery) {
    return window.matchMedia(ui_query_to_text[query]).matches;
}

export function uiGetMediaQuery(query: UIMediaQuery) {
    return window.matchMedia(ui_query_to_text[query]);
}
